import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {createBaseQueryArgs} from './api/createBaseQueryArgs';

export const localApi = createApi({
  reducerPath: 'localApi',
  tagTypes: [
    'UserPreference',
    'Work',
    'Series',
    'FilterSet',
    'ColumnSet',
    'Media',
    'Agent',
    'Prize',
    'Notes',
    'MergeSuggestions',
  ],
  endpoints: () => ({}),
  baseQuery: fetchBaseQuery(createBaseQueryArgs('http://localhost:8399/')),
});
